import {atom} from "jotai";

export  const userInfo ={
  email: '',
  name:'',
  id:''
}
/**
 * login parameter Info
 * @type {{password: string, id: string}}
 */
export const loginParams= {
  username: '',
  password: ''
}

export  const adminInfo ={
  email: '',
  name:'',
  convertedUser: localStorage.getItem('mediaUsername') ? localStorage.getItem('mediaUsername') : "",
  id:'',
  accountProfile: ''
}
export const selectedAdverIdsAtom = atom(new Set());
export const overviewCacheAtom = atom(null); // response 원본 배열 저장
export const tokenResultAtom = atom({
  accessToken:'',
  refreshToken:'',
  id:'',
  role:'',
  name:'',
  serverName:''
})

export const findIdParams ={
  email: '',
  phone: ''
}

export const findIdResult = []

export const findPasswordParams ={
  phone: '',
  email: '',
  username: ''
}
